const Strategy = require('../Strategy');
const policyService = require('../../TaxAuthority/PolicyService');
const roundNumber = require('../Utility/RoundNumber');

class StrategyPercentageNoStakeWithNonTaxableFixedAmount extends Strategy {
    constructor() {
        super();
    }

    /**
     * 
     * @param {string} policy 
     * @param {number} amount 
     * @param {number} stake 
     * @returns {number}
     */
    getTaxAmount(policy, amount, stake) {
        amount = parseFloat(amount);
        stake = parseFloat(stake);

        let rule = policyService.getPolicyRule(policy, amount);
        if (!rule) return 0.00;

        amount = amount - stake - rule.nonTaxableFixedAmount;
        if (amount <= 0) return 0.00;

        let taxAmount = roundNumber(amount * rule.taxValue / 100, this.calculationRoundDecimals, rule.roundType);

        return taxAmount;
    }
}

module.exports = new StrategyPercentageNoStakeWithNonTaxableFixedAmount();
